export default "__VITE_ASSET__BBEajBZM__"